import { render } from "./ChartBuilder.vue?vue&type=template&id=655fe190"
import script from "./ChartBuilder.vue?vue&type=script&setup=true&lang=js"
export * from "./ChartBuilder.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/Insights/ChartBuilder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "655fe190"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('655fe190', __exports__)) {
    api.reload('655fe190', __exports__)
  }
  
  module.hot.accept("./ChartBuilder.vue?vue&type=template&id=655fe190", () => {
    api.rerender('655fe190', render)
  })

}


export default __exports__